<template>
    <div class="calendar__header" v-if="access === 'patient'">
        <div class="calendar__header" v-if="getFreeCells">
            <strong class="calendar__msg r-strong">Выберите свободную дату</strong>
        </div>
        <div class="calendar__header" v-else>
            <strong class="calendar__msg r-strong">Свободного времени для записи нет</strong>
        </div>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapMutations} from 'vuex';

    export default {
        name: 'CalendarTimeMesaage',

        computed: {
            ...mapState([
                'access',
            ]),
            ...mapGetters([
                'getFreeCells'
            ]),
        },
    }
</script>
